const CAR_PRINT_STYLES = `
  @page { size: A4 portrait; margin: 12mm; }
  * { box-sizing: border-box; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  html, body { margin: 0; padding: 0; height: auto; overflow: visible; }
  body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #212529; background: #fff; }
  .car-report-print .car-print-grid { border-collapse: collapse; width: 100%; }
  .car-report-print .car-print-grid th,
  .car-report-print .car-print-grid td { border: 1px solid #6c757d; padding: 5px 7px; }
  .car-report-print .car-print-title {
    text-align: center; font-size: 16px; font-weight: 700; letter-spacing: 0.4px; margin: 0 0 14px;
  }
  .car-report-print img { max-width: 240px; max-height: 180px; object-fit: contain; page-break-inside: avoid; }
  .car-print-page + .car-print-page { page-break-before: always; break-before: page; }
`;

/** Print CAR via hidden iframe — print dialog only, output splits on page breaks (3 pages). */
export function printCarReport(rootEl, documentTitle = 'CAR-Report') {
    if (!rootEl || !rootEl.innerHTML) {
        window.alert('Nothing to print yet.');
        return;
    }

    const safeTitle = String(documentTitle).replace(/[<>&"]/g, '');
    const contentHtml = rootEl.innerHTML;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('title', 'CAR print');
    iframe.setAttribute('style', 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden');
    document.body.appendChild(iframe);

    const win = iframe.contentWindow;
    const doc = win.document;
    doc.open();
    doc.write(`<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8" />
<title>${safeTitle}</title>
<style>${CAR_PRINT_STYLES}</style>
</head>
<body>${contentHtml}</body>
</html>`);
    doc.close();

    const cleanup = () => {
        if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
        }
    };

    const runPrint = () => {
        try {
            win.focus();
            win.print();
        } catch (e) {
            cleanup();
            window.alert('Print failed. Please try again.');
        }
    };

    if (win.onafterprint !== undefined) {
        win.onafterprint = cleanup;
    } else {
        setTimeout(cleanup, 2000);
    }

    const images = doc.images;
    if (!images || images.length === 0) {
        setTimeout(runPrint, 150);
        return;
    }

    let loaded = 0;
    const tryPrint = () => {
        loaded += 1;
        if (loaded >= images.length) {
            setTimeout(runPrint, 100);
        }
    };

    Array.from(images).forEach((img) => {
        if (img.complete) {
            tryPrint();
        } else {
            img.addEventListener('load', tryPrint);
            img.addEventListener('error', tryPrint);
        }
    });
}
